import type { ReactNode } from "react";
import "./ui.css";
import { RequiredMark } from "./RequiredMark.js";

/**
 * Beschriftetes Formularfeld (Label über dem Control).
 *
 * `variant` wählt genau eine Klasse, statt beide zu kombinieren: `ui-field`
 * und `inspector-field` sind zwei vollständige, unabhängige Stilsätze
 * (Letzterer mit 16 Regeln in `editor.css`). Bis Phase 8 existierten dafür
 * zwei separate Komponenten — `components/ui/Field.tsx` hatte **null**
 * Verwendungen, weil `editor/Field.tsx` daneben stand und überall importiert
 * wurde.
 */
export function Field({
  label,
  htmlFor,
  required = false,
  variant = "ui",
  children,
}: {
  label: string;
  htmlFor?: string;
  required?: boolean;
  variant?: "ui" | "inspector";
  children: ReactNode;
}) {
  return (
    <label
      className={variant === "inspector" ? "inspector-field" : "ui-field"}
      htmlFor={htmlFor}
    >
      <span className="ui-field-label">
        {label}
        {required ? <RequiredMark /> : null}
      </span>
      {children}
    </label>
  );
}
